import { get } from "./apiClient";

export default {
  async getKey() {
    return await get("analytics/applicationInsights");
  }
};
